import isToday from 'date-fns/isToday'

export function getView(start_time, state) {
  return (
    isToday(Date.parse(`${start_time}Z`)) &&
    ['SCHEDULED', 'CHECKED_IN', 'SEATED'].includes(state)
  )
}
